module.exports = __webpack_public_path__ + "img/en-US.bd1d61c5.png";